module.exports = __webpack_public_path__ + "static/BAT-cover-image-f25e76578d9724f1bfa58850ec218009.jpg";